import React from 'react'
import { Link } from 'react-router-dom'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import CopyToClipboardUI from '../../../widgets/output/CopyToClipboardUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import SearchUI from '../../../widgets/input/SearchUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
// import './RepaymentInitiatedList.css'

const RepaymentInitiatedListUI = ({context, repaymentList,
    showDetails, onShowDetails, selectedRowId,
    onDeclineClick, declineSubmitted, declineSuccessMsg, declineErrorList,
    onApproveClick, approveSubmitted, approveSuccessMsg, approveErrorList,
    onRefreshClick, onCopyToClipboard, copyToClipboardText,
    searchFilter, onSearchFilterChange
  }) =>
  <div className='su_accs'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
        />
      }
      right={
        <ActionRightUI
          context={context}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <div className='g_flex_h g_m_bottom_50'>
      <span className='g_muted g_small'>Loan repayment amounts and penalty messages to be approved</span>
      <span>{repaymentList.length} repayment{repaymentList.length == 1 ? '' : 's'} displayed</span>
    </div>

    <LRTableBodyUI className='g_m_top_50'>
      {
        repaymentList.map((repayment, i) =>
          <TxnRowList key={i} context={context} repayment={repayment}
            showDetails={showDetails} onShowDetails={onShowDetails} selectedRowId={selectedRowId}
            onDeclineClick={onDeclineClick} declineSubmitted={declineSubmitted}
            declineSuccessMsg={declineSuccessMsg} declineErrorList={declineErrorList}
            onApproveClick={onApproveClick} approveSubmitted={approveSubmitted}
            approveSuccessMsg={approveSuccessMsg} approveErrorList={approveErrorList}
            onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
          />
        )
      }
    </LRTableBodyUI>

  </div>

  const TxnRowList = ({context, repayment, showDetails, onShowDetails, selectedRowId,
    onDeclineClick, declineSubmitted, declineSuccessMsg, declineErrorList,
    onApproveClick, approveSubmitted, approveSuccessMsg, approveErrorList,
    onCopyToClipboard, copyToClipboardText,
  }) =>
    <LRTableRowUI
      context={context} className='g_flex_top'
        left={<RowLeftUI context={context} repayment={repayment}
        showDetails={showDetails} onShowDetails={onShowDetails} selectedRowId={selectedRowId}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
      />}
      right={<RowRightUI context={context} repayment={repayment}
        selectedRowId={selectedRowId}
        onDeclineClick={onDeclineClick} declineSubmitted={declineSubmitted}
        declineSuccessMsg={declineSuccessMsg} declineErrorList={declineErrorList}
        onApproveClick={onApproveClick} approveSubmitted={approveSubmitted}
        approveSuccessMsg={approveSuccessMsg} approveErrorList={approveErrorList}
      />}
    />

  const RowLeftUI = ({context, repayment, showDetails, onShowDetails, selectedRowId,
    onCopyToClipboard, copyToClipboardText,
    }) =>
    <div className='g_flex_v'>
      <span className='g_muted'>
        {repayment.emiInitiatedDateF1}
      </span>
      <Link className='g_no_wrap_2' to={`/su/loans/${repayment.loanId}/repayments`}>
        <b>{repayment.accountName}</b> {repayment.loanName}
      </Link>
      <span className='g_flex_h g_flex_left'>
        {repayment.scheduledDateF1}
        <span className='g_muted g_m_left_100 g_m_right_100'>{repayment.scheduledDate}</span>
        <CopyToClipboardUI text={repayment.loanId}
          onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        />
      </span>
      <div className='g_flex_h g_flex_left g_flex_top g_m_top_25'>
        <LabelAndValueUI align='right' className='g_m_right_100' label='Interest'>{repayment.interestF5}</LabelAndValueUI>
        <LabelAndValueUI align='right' className='g_m_right_100' label='Principal'>{repayment.principalF5}</LabelAndValueUI>
        <LabelAndValueUI align='right' className='g_m_right_100' label='EMI'>{repayment.emiF5}</LabelAndValueUI>
        <LabelAndValueUI align='right' className='g_m_right_100' label='EMI Tax'>
          {
            repayment.emiTaxList && repayment.emiTaxList.map((tax, j) =>
              <span key={j}>
                { j != 0 && <>+</>}
                {tax.amountF5}
              </span>
            )
          }
        </LabelAndValueUI>
        <LabelAndValueUI align='right' className='g_m_right_100' label='DSRA Int'>{repayment.drsaDipInterestF5}</LabelAndValueUI>
        <LabelAndValueUI align='right' className='g_m_right_100' label='Default Int'>{repayment.defaultInterestF5}</LabelAndValueUI>
        <LabelAndValueUI align='right' className='g_m_right_100' label='Levied'>{repayment.leviedAmountF5}</LabelAndValueUI>
        <LabelAndValueUI align='right' className='g_m_right_100' label='Waived'>{repayment.waivedAmountF5 ? '('+repayment.waivedAmountF5+')' : ''}</LabelAndValueUI>
      </div>
      <span className='g_info g_m_top_25'>{repayment.remarks}</span>
      <Link onClick={onShowDetails} to='#' data-row-id={`${repayment.loanId}:${repayment.scheduledDate}`}>
        Details
      </Link>
      {
        showDetails && selectedRowId===`${repayment.loanId}:${repayment.scheduledDate}` &&
        <>
          <span>
            {
              repayment.dsraDipInterestMessage &&
              <>
                <b>Message to borrower for DSRA dip penalty during last month</b>
                <div dangerouslySetInnerHTML={{ __html: repayment.dsraDipInterestMessage }} />
              </>
            }
            {
              repayment.defaultInterestMessage &&
              <>
                <b>Message to borrower for default penalty during last month</b>
                <div dangerouslySetInnerHTML={{ __html: repayment.defaultInterestMessage }} />
              </>
            }
            {
              repayment.dsraDipMessage &&
              <>
                <b>Message to client for dip incurred during current EMI repayment</b>
                <div dangerouslySetInnerHTML={{ __html: repayment.dsraDipMessage }} />
              </>
            }
          </span>
          <span className='g_muted g_small g_m_top_25'>{repayment.paymentRecord}</span>
        </>
      }
    </div>

  const RowRightUI = ({context, repayment, selectedRowId,
    onDeclineClick, declineSubmitted, declineSuccessMsg, declineErrorList,
    onApproveClick, approveSubmitted, approveSuccessMsg, approveErrorList,
  }) =>
    <div className='g_flex_v g_text_right'>
      <span>{repayment.emiWithLateInterestAndTaxF5}</span>
      {
        context.permissions.includes('su_superuser') &&
        <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
          label='Decline' rowId={`${repayment.loanId}:${repayment.scheduledDate}`}
          onClick={onDeclineClick} alignLeft={false}
          busy={declineSubmitted && selectedRowId === `${repayment.loanId}:${repayment.scheduledDate}`}
          successMsg={selectedRowId === `${repayment.loanId}:${repayment.scheduledDate}` ? declineSuccessMsg : ''}
          errorList={selectedRowId === `${repayment.loanId}:${repayment.scheduledDate}` ? declineErrorList : ''}
        />
      }
      {
        context.permissions.includes('su_manage') &&
        <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
          label='Approve' rowId={`${repayment.loanId}:${repayment.scheduledDate}`}
          onClick={onApproveClick} alignLeft={false}
          busy={approveSubmitted && selectedRowId === `${repayment.loanId}:${repayment.scheduledDate}`}
          successMsg={selectedRowId === `${repayment.loanId}:${repayment.scheduledDate}` ? approveSuccessMsg : ''}
          errorList={selectedRowId === `${repayment.loanId}:${repayment.scheduledDate}` ? approveErrorList : ''}
        />
      }
    </div>

  const ActionLeftUI = ({context, onRefreshClick}) =>
    <span className='g_flex_left g_flex_h'>
      <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
      <span className='g_m_left_100 g_large'><b>Repayment approvals</b></span>
    </span>

  const ActionRightUI = ({context, messageList, searchFilter, onSearchFilterChange}) =>
    <div className='g_flex_h'>
      <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
    </div>

export default RepaymentInitiatedListUI
